export const BASE_URL = `https://api.bergregions.pl`;
export const STATIONS = `/api/v1/ski-info/45904333/stations`;
export const KOTELNICA = `/5fd38137a539d93aea576f54/weather`;
export const ALERT = `/5fd38137a539d93aea576f54/announcements`;
